import React, { Fragment } from "react";
import { useTranslation } from "react-i18next";
import { Container, Row } from "reactstrap";
import { Breadcrumbs } from "../../AbstractElements";
import { Col } from "react-bootstrap";
import TestHome from './TestHome';

export default function TestList() {
    const { t } = useTranslation();
    return (
        <Fragment>
            <Breadcrumbs mainTitle={t("List of Test Reports")} parent={t("Home")} title={t("List of Test Reports")} />
            <Container fluid={true}>
                <Row>
                    <Col className="h-100">
                        <TestHome />
                    </Col>
                </Row>
            </Container>
        </Fragment>
    )
}
